import { get } from 'lodash-es';
import { call, put, takeLatest } from 'redux-saga/effects';
import { setActionLoaderFalse, setActionLoaderTrue } from '../../../reducers/actionLoader';
import { fetch_hot_pursuit_data } from '../../../../apis/landing/sessionLess/stockNews';
import { getHotPursuit, setHotPursuitData, setHotPursuitPullRefreshState } from '../../../reducers/landing/stockLanding/stockNews';
import { PULL_REFRESH_STATE } from '../../../../constants/common';
import { resetActionError, setActionError } from '../../../reducers/actionError';

export default function* fetchMfLandingData() {
	yield takeLatest(getHotPursuit.toString(), handleGetHotPursuit);
}

function* handleGetHotPursuit({ payload = {} }) {
	const { noOfRecords = 5, isPullToRefresh = false, Api, sessionLessServer = '', } = payload;
	try {
		yield put(setActionLoaderTrue(getHotPursuit));
		yield put(resetActionError(getHotPursuit));
		const body = {
			noofrecords: noOfRecords,
		};
		const response = yield call(fetch_hot_pursuit_data, Api, sessionLessServer, body);
		const data = get(response, 'data', []);
		yield put(setHotPursuitData(data));
		if (isPullToRefresh) {
			yield put(
				setHotPursuitPullRefreshState({
					[PULL_REFRESH_STATE.IS_SUCCESS]: true,
				}),
			);
		}
	} catch (error) {
		if (isPullToRefresh) {
			yield put(
				setHotPursuitPullRefreshState({
					[PULL_REFRESH_STATE.IS_FAILED]: true,
				}),
			);
		} else {
			yield put(setActionError({ actionName: getHotPursuit, isFetchFailed: true, message: error.message }));
		}
	} finally {
		yield put(setActionLoaderFalse(getHotPursuit));
	}
}
